import mapKnownValues from "@/utils/mapKnownValues";
import { ItemStatusType } from "@/classes/itemStatusType";

export type UserRfidData = {
  id: "string";
  rawrfid: "string";
  rfid: "string";
  ukey: "string";
  inactivatedAt: string; // Date
  createdAt: string; // Date
  itemStatus: "string";
};

export default class UserRrfid {
  id = "";
  rawrfid = "";
  rfid = "";
  ukey = "";
  inactivatedAt: Date | null = null;
  createdAt = new Date();
  itemStatus: ItemStatusType = ItemStatusType.ACTIVE;

  constructor(params: Partial<UserRrfid | UserRfidData> = {}) {
    mapKnownValues(this, params);

    if (params.inactivatedAt) {
      this.inactivatedAt = new Date(params.inactivatedAt);
    }
    if (params.createdAt) {
      this.createdAt = new Date(params.createdAt || new Date());
    }
  }
}
